module.exports = __webpack_public_path__ + "img/jyl.1f2876b2.png";